<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
//import { DataTable } from "simple-datatables";
import setTooltip from "@/assets/js/tooltip.js";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useToast } from "vue-toastification";

//Table
import DataTable from "primevue/datatable";
import Column from "primevue/column";
//import ColumnGroup from "primevue/columngroup"; // optional
//import Row from "primevue/row"; // optional

const store = useStore();
const items = ref([]);

const toast = useToast();

const fetchItems = async () => {
  const querySnapshot = await getDocs(collection(db, "auctionItems"));
  const currentDate = new Date();

  items.value = querySnapshot.docs
    .map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
    .filter((item) => {
      if (item.isSponsorDefault) return false;
      const endDate = new Date(item.enddate.seconds * 1000);
      return endDate < currentDate;
    });
};

const formatDate = (timestamp) => {
  const date = new Date(timestamp.seconds * 1000);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const daysLeft = (endDateTimestamp) => {
  const currentDate = new Date();
  const endDate = new Date(endDateTimestamp.seconds * 1000);
  const timeDiff = endDate - currentDate;
  if (timeDiff < 0) {
    return 0;
  }
  const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
  return daysLeft;
};

onMounted(async () => {
  const message = localStorage.getItem("categoryMessage");

  if (message) {
    toast.success(message);
    localStorage.removeItem("categoryMessage");
  }
  await fetchItems();
  setTooltip(store.state.bootstrap);
});
</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Closed Auction Items & Donation Items.</h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto"></div>
              </div>
            </div>
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive table table-flush">
              <DataTable
                :value="items"
                paginator
                :rows="10"
                :rowsPerPageOptions="[10, 20, 50]"
                tableStyle="min-width: 50rem"
              >
                <Column field="name" header="Name"
                  ><template #body="{ data }">
                    <router-link
                      :to="{
                        name: 'View Sold Item',
                        params: { id: data.id },
                      }"
                    >
                      <h6 class="my-auto ms-3">{{ data.name }}</h6>
                    </router-link></template
                  ></Column
                >
                <Column field="isPaid" header="Payment Status"
                  ><template #body="{ data }"
                    ><span
                      :class="{
                        'badge badge-success badge-sm': data.isPaid,
                        'badge badge-info badge-sm': !data.isPaid,
                      }"
                    >
                      {{ data.isPaid ? "Paid" : "Unpaid" }}
                    </span></template
                  ></Column
                >
                <Column field="enddate" header="End date">
                  <template #body="{ data }">
                    {{ formatDate(data.enddate) }} ({{ daysLeft(data.enddate) }}
                    days left)
                  </template>
                </Column>
                <Column field="id" header="Action" width="10%">
                  <template #body="{ data }">
                    <router-link
                      :to="{
                        name: 'View Sold Item',
                        params: { id: data.id },
                      }"
                      class="mx-3"
                      data-bs-toggle="tooltip"
                      data-bs-original-title="View Item"
                    >
                      <i class="fas fa-pencil-alt text-secondary"></i>
                    </router-link>
                  </template>
                </Column>
                <template #footer>
                  In total there are
                  {{ items ? items.length : 0 }} items.
                </template>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
